<template lang="pug">
  .contact-confirm-switch(@click.stop="onSwitch()")
    input(type="checkbox" v-model="switchValue")
    label.switch-label()
        span
    .switch-img
</template>

<script lang="ts">
import { Component, Prop, Vue, Watch } from "vue-property-decorator";

/**
 * 確認済/未確認を切り替えるスイッチコンポーネント
 */
@Component
export default class ConfirmSwitch extends Vue {
  /**
   * 親コンポーネントから受け取るスイッチの値
   */
  @Prop({
    default: () => {
      return false;
    }
  })
  value!: boolean;

  /**
   * 本コンポーネントのチェックボックスに紐づくスイッチの値
   */
  switchValue: boolean = false;

  /**
   * 親コンポーネントから渡された値に変更があった場合、スイッチの値を同期する
   */
  @Watch("value")
  changeSwitchValue(newValue: boolean): void {
    this.switchValue = newValue;

    return;
  }

  /**
   * vue lifecycle created
   *
   * 親コンポーネントから渡されてきた値でスイッチの値を初期化する
   */
  created(): void {
    this.switchValue = this.value;

    return;
  }

  /**
   * スイッチ切り替え時イベント
   */
  onSwitch(): void {
    this.$emit("onSwitch", this.switchValue);

    return;
  }
}
</script>

<style lang="scss" scoped>
@import "../../styles/pc/_colors.scss";

// ボタン領域
.contact-confirm-switch {
  line-height: 40px;
  letter-spacing: 0;
  text-align: center;
  position: relative;
  width: 94px;

  // チェックボックス
  input[type="checkbox"] {
    display: none;
  }

  // リンクであることが分かるようにカーソルを変える
  cursor: pointer;

  // ラベル
  label.switch-label {
    display: block;
    box-sizing: border-box;
    height: 42px;
    border: 2px solid $errormessage-font-color;
    border-radius: 4px;
    font-size: 16px;
    background: rgba(255, 255, 255, 1);
    margin-bottom: 0;
    // リンクであることが分かるようにカーソルを変える
    cursor: pointer;
  }

  // ラベル(ON)
  input[type="checkbox"]:checked + label {
    // ON時の枠線
    border-color: $switch-bordercolor;
  }

  // 表示する文字(OFF)
  label span:after {
    content: "未確認";
    padding: 0 0 0 28px;
    color: $errormessage-font-color;
  }

  // 表示する文字(ON)
  input[type="checkbox"]:checked + label span:after {
    content: "確認済";
    padding: 0 28px 0 0;
    color: $switch-bordercolor;
  }

  // トグル部分
  .switch-img {
    position: absolute;
    width: 28px;
    height: 28px;
    background: $errormessage-font-color;
    top: 7px;
    left: 4px;
    border-radius: 2px;
    transition: 0.4s;
  }

  // トグル部分(ON)
  input[type="checkbox"]:checked ~ .switch-img {
    transform: translateX(58px);
    background: $switch-bordercolor;
  }
}
</style>
